export default {
  inicio: { text: "Inicio" }
  , seguridad: {
    text: "Seguridad"
    , sub: {
      usuario: { text: "Usuarios" }
      , perfiles: { text: "Perfiles" }
      , perfilUsuario: { text: "Perfil de Usuario" }
    }
  }
  , catalogosOperativos: {
    text: "Catálogos Operativos"
    , sub: {
      status: { text: "Estatus" }
      , substatus: { text: "Sub Estatus" }
      , accion: { text: "Acción" }
      , vendor: { text: "Vendor" }
      , rep: { text: "Rep" }
      , campana: { text: "Campaña" }
      , agregador: { text: "Agregador" }
      , benefpref: { text: "Benef Pref" }
      , tipo: { text: "Tipo" }
      , contact: { text: "Contact" }
      , shoppings: { text: "Shoppings" }
      , posTest: { text: "Pos Test" }
      , statusPreContacto: { text: "Status Pre Contacto" }
      , popEntryExit: { text: "Pop Entry/Exit" }
      , se: { text: "SE" }
      , seOOB: { text: "SE OOB" }
      , iniciativa: { text: "Iniciativa" }
      , motivobaja: { text: "Motivo Baja" }
    }
  }
  , catalogosGeograficos: {
    text: "Catálogos Geográficos"
    , sub: {
      provincia: { text: "Provincia" }
      , localidad: { text: "Localidad" }
      , pais: { text: "País" }
      , lada: { text: "Código Telefónico" }
    }
  }
  , catalogosGenerales: {
    text: "Catálogos Generales"
    , sub: {
      plantillasCorreo: { text: "Plantillas Correo" }
      , parametros: { text: "Parámetros Sistema" }
      , archivos: { text: "Archivos" }
    }
  }
  , consultaBitacoras: {
    text: "Consulta Bitácoras"
    , sub: {
      bitacora: { text: "Bitácora Acceso" }
      , reportesAuditoria: { text: "Reportes Auditoría" }
      , monitorCorreos: { text: "Monitor de Notificaciones" }
      , geolocalizacion: { text: "Bitácora de Geolocalización" }
    }
  }
  , filetransaction: {
    validator: { text: "Validación / Envío Archivos" }
    , importer: { text: "Importador" }
  }
  , bases: {
    text: "Catálogos Base"
    , sub: {
      acuerdo: { text: "Acuerdos" }
      , subindustria: { text: "Sub-Industria" }
      , banco: { text: "Banco" }
      , codigoindustrial: { text: "Código Industrial" }
      , partner: { text: "Partner" }
      , proveedorpos: { text: "Proveedor POS" }
      , merchandising: { text: "Merchandising" }
      , canalaceptacion: { text: "Canal Aceptación" }
    }
  }
  , base: { text: "Consulta Bases" }
  , reportes: {
    text: "Reportes"
    , sub: {
      reporteexclusiones: { text: "Reporte de Exclusiones" }
      , reporteusuarios: { text: "Reporte de Usuarios" }
      , reportevisitas: { text: "Reporte de Visitas" }
    }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/menu.js